<script>

    import Editor from "./../Editor";

    export default {

        extends: Editor,

        inject: [
            '$pageComponent',
        ],

        computed: {

            loopEditorComponent()
            {
                // TODO Check?
                return this.$parent;
            },

            loopIndex()
            {
                // TODO Filter on LoopItemEditors first?
                return this.loopEditorComponent.$children.indexOf(this);
            },

            canvasBlock()
            {
                return this.loopEditorComponent.canvasBlock;
            },

            canvasBlocks()
            {
                // Return children.
                return _.filter(this.loopEditorComponent.canvasBlock.children, canvasBlock => {
                    return canvasBlock.key.startsWith(this.loopEditorComponent.loopKey + '.' + this.loopIndex + '.');
                });
            },

            loopItems()
            {
                return this.loopEditorComponent.loopItems;
            },

            loopItem()
            {
                return this.loopItems[this.loopIndex];
            },

            editableComponent()
            {
                // @ugly We assume the editor is for this current selection.
                return this.pageComponent.selection.currentSelection;
            },

            panelComponent()
            {
                // Use default?
                if(!this.editableData.itemPanel)
                    return window.Vue.options.components['common-canvas-editor-canvas-document-editors-loop-loopitempanel'];

                // Determine custom component.
                let componentTag = 'common-canvas-blocks-' + this.canvasBlock.block.replace('.', '-').toLowerCase() + '-admin-' + this.editableData.itemPanel.toLowerCase();
                let component = window.Vue.options.components[componentTag]

                if(!component)
                    throw {
                        message: 'Loop item panel not found!',
                        componentTag,
                        component,
                    };

                return component;
            },

        },

        watch: {

            'loopEditorComponent.moving'(newVal)
            {
                // Show / hide move cursor.
                this.element.toggleClass('canvas-loop-move', newVal);
            },

        },

    }

</script>

<style lang="scss">

    .canvas-loop-move {
        cursor: move !important;
        outline: 2px solid transparent !important;
        transition: outline-color .4s linear, transform .3s !important;

        &:hover {
            outline: 2px solid #0888c899 !important;
        }
    }

</style>